import React from "react";

import { components, type GroupBase, type OptionProps } from "react-select";

export function CheckboxOption<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>({ children, isSelected, ...rest }: OptionProps<Option, IsMulti, Group>) {
  return (
    <components.Option {...rest} isSelected={isSelected}>
      <div className="flex items-center">
        <input
          type="checkbox"
          readOnly
          checked={isSelected}
          className="w-3 h-3 mr-2"
        />
        {children}
      </div>
    </components.Option>
  );
}
